<template>
  <div class="space-y-6">
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Tracking & Technology
      </h3>
      <div class="space-y-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <UiControl id="integrations-ga4" label="Has Google Analytics 4?">
            <UiRadioGroup
              id="integrations-ga4-radio"
              v-model="form.ga4_status"
              :options="yesNoUnsure"
            />
          </UiControl>
          <UiControl id="integrations-gtm" label="Has Google Tag Manager?">
            <UiRadioGroup
              id="integrations-gtm-radio"
              v-model="form.gtm_status"
              :options="yesNoUnsure"
            />
          </UiControl>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <UiControl id="integrations-call-tracking" label="Call Tracking Provider">
            <UiSelect
              id="integrations-call-tracking-select"
              v-model="form.call_tracking_provider"
              :options="callTrackingOptions"
            />
          </UiControl>
          <UiControl id="integrations-crm" label="CRM / Lead Destination">
            <UiSelect
              id="integrations-crm-select"
              v-model="form.crm_destination"
              :options="crmOptions"
            />
          </UiControl>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import UiControl from '~/javascript/components/ui/form/control/control.vue'
import UiSelect from '~/javascript/components/ui/form/select/select.vue'
import UiRadioGroup from '~/javascript/components/ui/form/radio/radio_group.vue'

const props = defineProps({
  stepKey: { type: String, required: true },
  label: { type: String, required: true },
  onboarding: { type: Object, required: true },
  mode: { type: String, required: true }
})

const yesNoUnsure = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'unsure', label: 'Unsure' }
]

const callTrackingOptions = [
  { id: 'callrail', title: 'CallRail' },
  { id: 'calltrackingmetrics', title: 'CallTrackingMetrics' },
  { id: 'whatconverts', title: 'WhatConverts' },
  { id: 'none', title: 'None - Need to Set Up' },
  { id: 'other', title: 'Other' }
]

const crmOptions = [
  { id: 'gohighlevel', title: 'GoHighLevel' },
  { id: 'hubspot', title: 'HubSpot' },
  { id: 'salesforce', title: 'Salesforce' },
  { id: 'email_only', title: 'Email Only' },
  { id: 'other', title: 'Other' }
]

const form = ref({
  ga4_status: '',
  gtm_status: '',
  call_tracking_provider: '',
  crm_destination: ''
})

onMounted(() => {
  const o = props.onboarding
  form.value.ga4_status = o.ga4_status || ''
  form.value.gtm_status = o.gtm_status || ''
  form.value.call_tracking_provider = o.call_tracking_provider || ''
  form.value.crm_destination = o.crm_destination || ''
})

defineExpose({
  getData: () => ({ ...form.value })
})
</script>
